var React = require('react');

function Windows (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0,12.402L35.687,7.542L35.703,41.965L0.033,42.168L0,12.402ZM35.67,45.931L35.698,80.384L0.028,75.48L0.026,45.7L35.67,45.931ZM39.996,6.906L87.314,0L87.314,41.527L39.996,41.903L39.996,6.906ZM87.325,46.255L87.314,87.595L39.996,80.917L39.93,46.178L87.325,46.255Z"}));
}

Windows.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 88 88","version":"1.1","xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"}};

module.exports = Windows;

Windows.default = Windows;
